import { getHomeWebContent } from 'app/selectors/selector';
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { UpdateComponent } from '../../pages/UpdateComponent/updateComponent';

const UpdateComponentContainer: React.FC<any> = (props: any) => {
  return <UpdateComponent {...props} />;
};

const mapStateToProps = createStructuredSelector({
  contentStackData: getHomeWebContent()
});

export const mapDispatchToProps = (dispatch: Function) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateComponentContainer);
